export default "__VITE_ASSET__laKlJrZQ__"